<template>
  <div class="shouji-img">
    <img
      v-if="memberInfo.ykWorkPhoneInfo"
      src="@/assets/img/shouji.png"
      @click="handleShoujiCall"
      :loading="loading"
      alt=""
      :style="`width:${size}px;`"
    />
  </div>
</template>

<script>
export default {
  props: {
    callTo: {
      type: String,
    },
    caseId: {
      type: [String, Number],
      default: "",
    },
    contactId: {
      type: [String, Number],
      default: "",
    },
    size: {
      type: [String, Number],
      default: "18",
    },
  },
  data() {
    return {
      loading: false,
      memberInfo: JSON.parse(localStorage.getItem("user")).memberInfo,
    };
  },
  methods: {
    handleShoujiCall() {
      this.loading = true;
      this.$store
        .dispatch("call/handleShouJiCall", {
          callTo: this.callTo,
          caseId: this.caseId,
          contactId: this.contactId,
        })
        .then((res) => {
          let { code, msg, data } = res.data;
          if (code != 1) {
            this.$message({
              type: "warning",
              message: msg,
            });
          } else {
            // if (this.caseId) {
            //   this.get("osapi/Cases/getCall", {
            //     case_id: case_id,
            //   });
            //   const cur_route = this.$route;
            //   this.$store.dispatch("caseInfoPage/addCuiji", this.case_id);
            //   if (cur_route.path.indexOf("/CaseInfo") > -1) {
            //     if (this.case_id != this.$route.params.caseId) {
            //       // 操作过上下案件
            //       this.$router.push({
            //         path: "/CaseInfo/" + this.case_id,
            //         query: {
            //           id: this.case_id,
            //           listId: 0,
            //           callshow: true,
            //           detailtype: true,
            //         },
            //       });
            //     }
            //   } else {
            //     this.$router.push({
            //       path: "/CaseInfo/" + this.case_id,
            //       query: {
            //         id: this.case_id,
            //         listId: 0,
            //         callshow: true,
            //         detailtype: true,
            //       },
            //     });
            //   }
            // }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  mounted() {},
};
</script>

<style scoped>
.shouji-img {
  display: inline-block;
  cursor: pointer;
}
.shouji-img > img {
  display: inline-block;
}
</style>


// WEBPACK FOOTER //
// src/components/ShouJiCall.vue